// extracted by mini-css-extract-plugin
module.exports = {"heading":"aed17b9412--heading--X8lLy","phone":"aed17b9412--phone--mSVle","tablet":"aed17b9412--tablet--zjURs","desktop":"aed17b9412--desktop--bggBd"};